import { ADMIN_GNB_SECTIONS } from '@/shared/config';

export interface CurrentMenu {
  readonly section: string;
  readonly label: string;
}

/**
 * 주소에 맞는 GNB 위치 — 경로가 메뉴 경로와 같거나 그 하위(`/메뉴/...`)인 항목 중 가장 긴 것.
 * 상세·편집 화면(/quotes/:id, /products/editor/:id/edit-area)도 상위 메뉴로 보인다. 맞는 메뉴가 없으면 null.
 */
export const currentMenuOf = (pathname: string): CurrentMenu | null => {
  let best: { readonly path: string; readonly menu: CurrentMenu } | null = null;

  for (const section of ADMIN_GNB_SECTIONS) {
    for (const item of section.items) {
      const matches = pathname === item.path || pathname.startsWith(`${item.path}/`);
      if (matches && (best === null || item.path.length > best.path.length)) {
        best = { path: item.path, menu: { section: section.label, label: item.label } };
      }
    }
  }

  return best?.menu ?? null;
};
